import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../../utils/resolveProps'
import clearProps from '../../../utils/clearProps'

const config = {
  types: [],
  modifiers: ['inverse'],
  states: []
}
export default function Price(props) {
  const { data, inverse, ...rest } = props

  return (
    <div {...rest} className={resolveProps(props, config, 'Price')}>
      <p className="mdn-Price-prefix">{data.prefix}</p>
      <div className="mdn-Price-price">
        {data.price}
        <span className="mdn-Price-price-period">
          {data.period ? '/ ' + data.period : ''}
        </span>
      </div>
      <p className="mdn-Price-suffix">{data.suffix}</p>
    </div>
  )
}


